export default __webpack_public_path__ + "static/thumb-landscape-c8025a3570ebae7bd3795b0f53c023df.jpg";